<template>
  <div class="permission-test">
    <h3>权限指令测试</h3>

    <!-- 测试有权限的元素 -->
    <div v-permission="'user:view'" class="test-item">
      <span class="permission-badge success">✓</span>
      user:view 权限 - 应该显示
    </div>

    <!-- 测试无权限的元素 -->
    <div v-permission="'nonexistent:permission'" class="test-item">
      <span class="permission-badge error">✗</span>
      nonexistent:permission 权限 - 不应该显示
    </div>

    <!-- 测试另一个有权限的元素 -->
    <div v-permission="'video:generate'" class="test-item">
      <span class="permission-badge success">✓</span>
      video:generate 权限 - 应该显示
    </div>

    <!-- 测试另一个无权限的元素 -->
    <div v-permission="'admin:super'" class="test-item">
      <span class="permission-badge error">✗</span>
      admin:super 权限 - 不应该显示
    </div>

    <div class="info">
      <p>如果权限指令正常工作：</p>
      <ul>
        <li>带有 ✓ 的元素应该显示</li>
        <li>带有 ✗ 的元素应该隐藏</li>
      </ul>
      <p>当前用户权限：{{ currentPermissions }}</p>
    </div>
  </div>
</template>

<script>
import { getPermissions } from '@/api/auth'

export default {
  name: 'PermissionTest',
  data() {
    return {
      currentPermissions: []
    }
  },
  mounted() {
    this.currentPermissions = getPermissions() || []
  }
}
</script>

<style scoped>
.permission-test {
  padding: 20px;
  max-width: 600px;
  margin: 0 auto;
}

.test-item {
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #f9f9f9;
}

.permission-badge {
  font-weight: bold;
  padding: 2px 6px;
  border-radius: 3px;
  margin-right: 10px;
}

.permission-badge.success {
  background: #d4edda;
  color: #155724;
}

.permission-badge.error {
  background: #f8d7da;
  color: #721c24;
}

.info {
  margin-top: 20px;
  padding: 15px;
  background: #e9ecef;
  border-radius: 4px;
}

.info ul {
  margin: 10px 0;
  padding-left: 20px;
}

.info p {
  margin: 5px 0;
  font-weight: bold;
}
</style>
